import React from 'react';

const spinnerStyle = {
  width: 36,
  height: 36,
  border: '3px solid #E2E8F0',
  borderTop: '3px solid #EF1D28',
  borderRadius: '50%',
  animation: 'adminSpin 0.7s linear infinite',
};

const keyframes = `@keyframes adminSpin { to { transform: rotate(360deg); } }`;

export default function RocketLoader({ message = '' }) {
  return (
    <>
      <style>{keyframes}</style>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        <div style={spinnerStyle} />
        {message && <span style={{ color: '#64748B', fontSize: 13 }}>{message}</span>}
      </div>
    </>
  );
}

export function FullPageRocketLoader({ message = 'Loading…' }) {
  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <RocketLoader message={message} />
    </div>
  );
}
